import React, { FC, useState, useRef, useEffect } from 'react';
import './style.scss';

interface Props {
  // styleDef?: any;
  labelStyleDef?: any;
  // icon: string;
  selected?: string;
  label: string;
  field?: string;
  fieldIdx?: number;
  type?: string;
  // authInfoSet: string;
  btnClickEvt: (
    e: React.MouseEvent,
    mode: string,
    field?: string,
    fieldIdx?: number,
    customEvt?: any
  ) => void;
}

const CheckBox: FC<Props> = ({
  label,
  labelStyleDef,
  selected = 'off',
  type,
  btnClickEvt,
  field,
  fieldIdx,
}) => {
  // const [checkNodeDepth, setCheck] = useState({ checkd: label });
  const clickEvent = (e: any, type: string) => {
    btnClickEvt(e, type, field, fieldIdx);
  };
  return (
    <div className={['_checkbox_cus', type].join(' ')}>
      {label !== '' ? (
        <div className="_label" style={labelStyleDef}>
          {label}
        </div>
      ) : (
        ''
      )}
      <div className="_check_div">
        {selected === 'off' ? (
          <i className="ri-checkbox-blank-circle-line off" onClick={e => clickEvent(e, 'off')} />
        ) : (
          <i className="ri-checkbox-circle-line" onClick={e => clickEvent(e, 'on')} />
        )}
      </div>
    </div>
  );
};

export default CheckBox;
